module.exports = __webpack_public_path__ + "static/media/designsprint1.f17a76a0.jpg";